module.exports = __webpack_public_path__ + "img/m_w.a85c3c4c.png";